import { NgModule } from '@angular/core';
import { SharedModule } from '../../../common/modules/shared';
import { RegisterComponent } from './register/RegisterComponent'
import { HolRegisterService } from '../../services/HolRegisterService'
import { registerManagementRouting } from './RegisterRouting';

@NgModule({
    imports: [
        SharedModule,
        registerManagementRouting,
    ],
    declarations: [
        RegisterComponent,
    ],
    providers: [
        HolRegisterService
    ],
})

export class RegisterManagementModule { }


// WEBPACK FOOTER //
// ./src/holiday/parent/register-management/RegisterModule.ts